import { useTranslation } from 'react-i18next'

import { ClientContestCampaignResultDto } from '@model/ClientContestCampaignResultDto'

import { useGenerateDocumentFile } from '@hooks/useGenerateDocumentFile'

export const useCampaignContestFile = (props: {
  data: ClientContestCampaignResultDto[]
  campaignName?: string | null
}) => {
  const { data, campaignName } = props
  const { t } = useTranslation()
  const tableBody = () => {
    const headerCsvData = [
      [t('Campaigns.Ranking'), t('Campaigns.Account Number'), t('Campaigns.ROI')],
    ]
    return data.reduce((acc, row) => {
      acc.push([
        !isDisqualifiedRanking(row.ranking) ? row.ranking.toString() : t('N/A'),
        row.name || '',
        `${row.points}%`,
      ])
      return acc
    }, headerCsvData)
  }

  return useGenerateDocumentFile(
    'campaigns_contest_report_' + (campaignName || 'campaign'),
    tableBody()
  )
}

const isDisqualifiedRanking = (ranking?: number) => ranking === -1
